import { memo, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SERVICE_NAME_DEF, SERVICE_SHORT_NAME_DEF } from 'shared-modules/constants';
import styles from './tag.module.scss';

export const Tag = memo(({ serviceId, className, text, isShortServiceName }) => {
  const tagColor = useMemo(() => styles[serviceId] ?? styles.other, [serviceId]);
  const label = (() => {
    if (!serviceId) return text;
    if (isShortServiceName) return SERVICE_SHORT_NAME_DEF[serviceId];
    return SERVICE_NAME_DEF[serviceId];
  })();
  return <div className={classNames(styles.tag, tagColor, className)}>{label}</div>;
});

Tag.propTypes = {
  serviceId: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  isShortServiceName: PropTypes.bool,
};

Tag.defaultProps = {
  className: undefined,
  text: '',
  serviceId: undefined,
  isShortServiceName: false,
};
